import { useAuthStore } from '@/store/auth'
import { useThemeStore } from '@/store/theme'
import { Moon, Sun, User, LogOut } from 'lucide-react'

export default function Header() {
  const { user, logout } = useAuthStore()
  const { isDark, toggle } = useThemeStore()

  return (
    <header className="sticky top-0 z-40 w-full border-b border-border bg-background/95 backdrop-blur">
      <div className="flex h-14 items-center justify-between px-4 md:px-6">
        {/* 左侧标题 - 手机端显示 */}
        <div className="md:hidden font-semibold">弗瑞云游</div>

        {/* 占位 - 电脑端 */}
        <div className="hidden md:block" />

        {/* 右侧操作 */}
        <div className="flex items-center gap-2">
          {/* 主题切换 */}
          <button
            onClick={toggle}
            className="p-2 rounded-lg hover:bg-secondary transition-colors"
          >
            {isDark ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
          </button>

          {/* 用户信息 */}
          <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-secondary">
            <User className="w-4 h-4" />
            <span className="text-sm hidden sm:inline">{user?.username}</span>
          </div>

          {/* 退出 */}
          <button
            onClick={logout}
            className="p-2 rounded-lg hover:bg-destructive/10 hover:text-destructive transition-colors"
          >
            <LogOut className="w-5 h-5" />
          </button>
        </div>
      </div>
    </header>
  )
}
